import Sidebar from '../../../../components/Layout/Sidebar'
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
import { capitalizeFirstLetter, decodeID, getLastURL, sidebarOpen } from '../../../../utils/Helper';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ServiceManagementDetailAction } from '../../../../redux/Action/DashboardAction';
import Spinner from '../../../../components/Spinner';
import { FormattedMessage } from 'react-intl';

const ServiceManagementView = () => {
    const location = useLocation();
    const viewId = getLastURL(location);
    const dispatch = useDispatch<any>();

    const params = { detail_id: decodeID(viewId) };
    const service_detail: any = useSelector((state: any) => state.ServiceManagementDetailState)



    useEffect(() => {
        dispatch(ServiceManagementDetailAction(params))
    }, [])

    const breadcrumbItems = [
        { title: 'dashboard', link: '/dashboard' },
        { title: 'Service_List', link: '/service-management' },
        { title: 'View_service_management' }
    ];

    return (
        <>
            <div className='col-lg-9 serviceMemberList'>
                {service_detail?.loading ? <Spinner /> : ""}
                <div className='dashboard bg-white'>
                    <div className='dashboardTop'>
                        <h2><button type='button' className='btn mobileMenu p-1 d-lg-none' onClick={() => { sidebarOpen() }} ><span className="icon-menu-right"></span></button> <FormattedMessage id="services_management" /></h2>
                        <Breadcrumb items={breadcrumbItems} />
                    </div>
                    <div className='dashboarcard'>
                        <div className='row gy-4 row-cols-1 row-cols-sm-3 row-cols-lg-6 serviceViewtop'>
                            <div className='col'>
                                <h6><FormattedMessage id="service_name"/></h6>
                                <p>{service_detail?.data?.data?.name ? service_detail?.data?.data?.name : "N/A"}</p>
                            </div>
                            <div className='col'>
                                <h6><FormattedMessage id="service_duration"/></h6>
                                <p>{service_detail?.data?.data?.duration ? service_detail?.data?.data?.duration : "N/A"}</p>
                            </div>
                            {/* <div className='col'>
                                        <h6>Services Created On</h6>
                                        <p>Thu, Jan 25, 2024  |  10:00 AM</p>
                                    </div>
                                    <div className='col'>
                                        <h6>Service Updated On</h6>
                                        <p>Thu, Jan 25, 2024  |  10:00 AM</p>
                                    </div> */}
                            <div className='col'>
                                <h6><FormattedMessage id="service_price"/></h6>
                                <p>{service_detail?.data?.data?.price ? `$${service_detail?.data?.data?.price}` : "N/A"}</p>
                            </div>

                        </div>
                        <div className='about my-4'>
                            <p>{service_detail?.data?.data?.description ? service_detail?.data?.data?.description : "N/A"}</p>
                        </div>
                        <div className='Addedstafflist'>
                            <h6><FormattedMessage id="staff_member"/></h6>
                            <ul className='addCategory placeholder-glow mt-3'>
                                {/* {
                                    service_detail?.data?.data?.selected_services?.length > 0 && service_detail?.data?.data?.selected_services?.map((item: any) => {
                                        
                                    staff_id
                                        return (    
                                            <>
                                                {
                                                    item?.salon_user?.length > 0 && (
                                                        <li>
                                                            <figure><img src={item?.salon_user[0]?.profile_pic ? item?.salon_user[0]?.profile_pic : "images/fely-beauty.jpg"} onError={(e: any) => e.target.src = "images/fely-beauty.jpg"} /></figure>
                                                            <p>{capitalizeFirstLetter(item?.salon_user?.[0]?.owner_name ? item?.salon_user?.[0]?.owner_name : "N/A")}</p>
                                                        </li>
                                                    )
                                                }

                                            </>
                                        )
                                    })
                                } */}
                                {
                                    service_detail?.data?.data?.selected_services?.length > 0 &&
                                    service_detail?.data?.data?.selected_services
                                        // Filter unique salon_user IDs
                                        .filter((item: any, index: any, self: any) =>
                                            index === self.findIndex((t: any) => (
                                                t?.salon_user?.[0]?.id === item?.salon_user?.[0]?.id
                                            ))
                                        )
                                        .map((item: any) => (
                                            <li key={item?.salon_user?.[0]?.id}>
                                                {
                                                    item?.salon_user?.length > 0 && (
                                                        <>
                                                            <figure>
                                                                <img
                                                                    src={item?.salon_user?.[0]?.profile_pic ? item?.salon_user?.[0]?.profile_pic : "images/fely-beauty.jpg"}
                                                                    onError={(e: any) => e.target.src = "images/fely-beauty.jpg"}
                                                                    alt={item?.salon_user?.[0]?.owner_name ? item?.salon_user?.[0]?.owner_name : "N/A"}
                                                                />
                                                            </figure>
                                                            <p>{capitalizeFirstLetter(item?.salon_user?.[0]?.owner_name ? item?.salon_user?.[0]?.owner_name : "N/A")}</p>
                                                        </>
                                                    )
                                                }
                                            </li>
                                        ))
                                }

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServiceManagementView